<template>
  <Head :title="props.title">
    <meta
      head-key="og:url"
      property="og:url"
      :content="usePage().props.value.ziggy?.location"
    />
    <meta head-key="og:title" property="og:title" :content="props.title" />
  </Head>
  <div class="bg-white">
    <MarketingHeader v-bind="props.header" />

    <SlideoverContainer border="border-l border-gray-200 dark:border-white/5">
      <main>
        <FlashMessage class="m-4" />
        <slot />
      </main>
    </SlideoverContainer>

    <MarketingFooter v-bind="props.footer" />
  </div>
</template>

<script setup>
import FlashMessage from '@/Common/Feedback/Alerts/FlashMessage.vue'
import SlideoverContainer from '@/Common/Overlays/Slideovers/SlideoverContainer.vue'
import MarketingFooter from '@/Components/Marketing/Footer/MarketingFooter.vue'
import MarketingHeader from '@/Components/Marketing/Header/MarketingHeader.vue'
import { Head, usePage } from '@inertiajs/inertia-vue3'
import { ref } from 'vue'

const props = defineProps({
  title: String,
  description: String,

  header: Object,
  footer: Object,
})

const navigation = [
  { name: 'Product', href: '#' },
  { name: 'Features', href: '#' },
  { name: 'Marketplace', href: '#' },
  { name: 'Company', href: '#' },
]

const mobileMenuOpen = ref(false)
</script>
